import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center pt-24 pb-16 overflow-hidden" data-id="element-144" data-mp="2hvm3g5hi9ga4">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-145" data-mp="28tcuhk1vxuyu">
        <img src="https://cdn.magicpatterns.com/uploads/fcKF7LPYXApRrE1fBXihTe/Banner_Mati_Sales_Page_2.png" alt="Pareja mirando el atardecer en la playa" className="w-full h-full object-cover object-[center_70%]" data-id="element-146" data-mp="28uefag8pdvtr" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-dark/70 via-charcoal-dark/50 to-charcoal-dark z-10" data-id="element-147" data-mp="2mup8hpxhjmi3"></div>
      </div>

      <div className="relative z-20 max-w-5xl mx-auto px-6 text-center" data-id="element-148" data-mp="2rr604u3w8izx">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-xs md:text-sm text-sand font-medium uppercase tracking-[0.25em] mb-6" data-id="element-149" data-mp="3fht81fdt78mh">
          Para hombres y mujeres de 30 a 50 años
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15
      }} className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-offwhite leading-tight mb-6 md:mb-8" data-id="element-150" data-mp="2bfrpg235ndrb">
          Hay una versión de vos que sabe exactamente{' '}
          <span className="text-sand" data-id="element-151" data-mp="2u4oi61iwly7f">quién es</span>,{' '}
          <span className="text-sand" data-id="element-152" data-mp="2u453qusgpry5">qué quiere</span> y cómo sostenerse.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-lg md:text-2xl text-offwhite-dim font-light mb-8 md:mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-153" data-mp="383ehzox3ybzh">
          ELEVATE es el camino de vuelta. 12 semanas para salir del piloto
          automático y construir desde quien realmente sos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.45
      }} data-id="element-154" data-mp="3ds61bgocd1j6">
          <Button href="https://wa.link/we351n" size="lg" withArrow className="shadow-2xl shadow-sand/20 w-full sm:w-auto" data-id="element-155" data-mp="3itlkf36ykxyx">
            Agendar llamada gratuita
          </Button>
          <p className="mt-6 text-xs md:text-sm text-offwhite-dim/70 font-medium tracking-wide uppercase" data-id="element-156" data-mp="lcr05g6to3u">
            Acompañamiento 1 a 1 · Solo 10 lugares disponibles
          </p>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 hidden md:block" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-157" data-mp="aaw5z00s4xtf">
        <a href="#lead" aria-label="Ir a la siguiente sección" data-id="element-158" data-mp="jaawu0kuzaeg">
          <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-sand to-transparent mx-auto" data-id="element-159" data-mp="23vhb79qthb0w"></div>
        </a>
      </motion.div>
    </section>;
}